const ServiceIcon13 = () => {
    return ( 
        <div>
            <svg width='40' height='40' version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 362.051 362.051">
                <g>
                    <path d="M39.697,136.466l90.905,65.659c0,0-11.219-52.193-39.845-107.182C90.764,94.943,46.432,116.262,39.697,136.466z" fill='white' stroke='black' strokeOpacity='1' strokeWidth='10px'/>
                    <path d="M43.625,277.313l86.983,82.496V211.101l-90.911-69.587C31.849,183.042,43.625,277.313,43.625,277.313z" fill='white' stroke='black' strokeOpacity='1' strokeWidth='10px'/>
                    <path d="M248.446,68.288V11.894c0-7.438-5.98-12.711-13.366-11.789l-127.306,16c-7.39,0.922-13.363,7.712-13.363,15.152v58.916
                        c0,0,38.721,72.391,47.982,136.363c9.252,63.973-8.424,135.515-8.424,135.515l168.347-49.663c0,0,39.562-57.238,14.31-134.677
                        C291.381,100.274,248.446,68.288,248.446,68.288z M204.391,56.271l-53.304,9.542c-0.855,0.155-1.705,0.222-2.54,0.222
                        c-6.795,0-12.833-4.862-14.065-11.792c-1.397-7.773,3.784-15.213,11.56-16.602l53.307-9.536
                        c7.771-1.388,15.211,3.785,16.605,11.56C217.354,47.448,212.173,54.88,204.391,56.271z" fill='white' stroke='black' strokeOpacity='1' strokeWidth='10px'/>
                </g>
            </svg>
        </div>
    );
}

export default ServiceIcon13;